import React, { useContext, useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import { QK } from "../../../base/qk";
import {
  deleteAlert,
  getAlerts,
  patchAlert,
} from "../../../api/services/notification";
import TaskDetailsModal from "../../PopupModal/TaskDetailsModal";

import { Visibility, Flag, ChatBubble, Delete } from "@mui/icons-material";
import TableComponent from "../../TableComponent/TableComponent";
import ReviewNoteModal from "../Modal/ReviewNoteModal";
import ConfirmModal from "../../ConfirmModal/ConfirmModal";
import { useSnackbar } from "notistack";
import MyContext from "../../../context/MyContext";

const AlertContent = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [showTaskModal, setShowTaskModal] = useState(false);
  const [showReviewNoteModal, setShowReviewNoteModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedAlert, setSelectedAlert] = useState(null);
  const alertsPerPage = 10;
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const { locationID } = useContext(MyContext);

  const { data: alerts, isLoading } = useQuery(
    [QK.alerts, currentPage, locationID],
    () => getAlerts(currentPage, locationID),
    {
      keepPreviousData: true,
      enabled: !!currentPage || !!locationID,
      refetchInterval: 60000,
    }
  );

  const totalRecords = alerts?.count || 0;
  const totalPages = Math.ceil(totalRecords / alertsPerPage);

  const handlePageChange = (event, page) => setCurrentPage(page);

  const handleShowTaskModal = (taskId) => {
    setSelectedTask(taskId);
    setShowTaskModal(true);
  };

  const handleFlag = async (id, is_flagged) => {
    const response = await patchAlert(id, { is_flagged: !is_flagged });
    if (response.status === 200) {
      queryClient.invalidateQueries(QK.alerts);
    } else {
      console.error("Error flagging alert:", response);
    }
  };
  const handleChat = (alert) => {
    setSelectedTask(alert.schedule_job);
    setShowReviewNoteModal(true);
  };
  const handleDelete = (id) => {
    setShowConfirmModal(true);
    setSelectedAlert(id);
  };

  const handleConfirmDelete = async () => {
    const response = await deleteAlert(selectedAlert);
    if (response.status === 204) {
      enqueueSnackbar("Alert deleted successfully", { variant: "success" });
      queryClient.invalidateQueries(QK.alerts);
    } else {
      console.error("Error deleting alert:", response);
    }
    setShowConfirmModal(false);
  };

  const columns = [
    {
      field: "created_at",
      headerName: "Date",
      render: (value) => value.split("T")[0],
    },
    {
      field: "created_at",
      headerName: "Time",
      render: (value) => value.split("T")[1],
    },
    { field: "notification_type", headerName: "Alert Reason" },
    { field: "client_name", headerName: "Service User" },
    { field: "candidate_name", headerName: "Employee" },
    {
      field: "visit_name",
      headerName: "Visit",
      render: (value) => value || "N/A",
    },
  ];

  const actions = [
    {
      icon: <Visibility />,
      color: "primary",
      handler: (alert) => handleShowTaskModal(alert.schedule_job),
    },
    {
      icon: <Flag />,
      color: "warning",
      handler: (alert) => handleFlag(alert.id, alert.is_flagged),
    },
    { icon: <ChatBubble />, color: "success", handler: handleChat },
    {
      icon: <Delete />,
      color: "error",
      handler: (alert) => handleDelete(alert.id),
    },
  ];
  const getRowSx = (row) => ({
    backgroundColor: row.is_flagged ? "#fff3cd" : "inherit",
  });

  return (
    <div>
      <TableComponent
        columns={columns}
        data={alerts?.results || []}
        actions={actions}
        isLoading={isLoading}
        pagination={{ totalPages, currentPage }}
        onPageChange={handlePageChange}
        size="small"
        getRowSx={getRowSx}
      />

      <TaskDetailsModal
        show={showTaskModal}
        handleClose={() => setShowTaskModal(false)}
        id={selectedTask}
      />
      <ReviewNoteModal
        open={showReviewNoteModal}
        handleClose={() => setShowReviewNoteModal(false)}
        jobId={selectedTask}
      />
      <ConfirmModal
        show={showConfirmModal}
        handleClose={() => setShowConfirmModal(false)}
        handleConfirm={handleConfirmDelete}
        title="Delete Alert"
        body="Are you sure you want to delete this alert?"
      />
    </div>
  );
};

export default AlertContent;
